import { type Config } from "./slice/config/types";

let globalConfig: Config | undefined;
let resolveGlobalConfig: ((config: Config) => void) | null = null;

export function setGlobalConfig(config: Config) {
	globalConfig = config;

	if (resolveGlobalConfig) {
		resolveGlobalConfig(config);
		resolveGlobalConfig = null;
	}
}

export function getGlobalConfig(): Config | undefined {
	return globalConfig;
}

export function getGlobalConfigAsync(): Promise<Config> {
	if (globalConfig) {
		return Promise.resolve(globalConfig);
	}

	return new Promise((resolve) => {
		resolveGlobalConfig = resolve;
	});
}
